import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as HomeBlackIcon } from '../../src/assets/SignUpIcon/home_black.svg';
import { ReactComponent as HomeWhiteIcon } from '../../src/assets/SignUpIcon/home_white.svg';
import { ReactComponent as CartBlackIcon } from '../../src/assets/SignUpIcon/cart_black.svg';
import { ReactComponent as CartWhiteIcon } from '../../src/assets/SignUpIcon/cart_white.svg';
import { ReactComponent as ProfileBlackIcon } from '../../src/assets/SignUpIcon/profile_black.svg';
import { ReactComponent as ProfileWhiteIcon } from '../../src/assets/SignUpIcon/profile_white.svg';
import './BottomBar.css';

const BottomBar = () => {
  const [activeTab, setActiveTab] = useState('home');
  const navigate = useNavigate();

  const handleTabClick = (tab, path) => {
    setActiveTab(tab);
    navigate(path);
  };

  return (
    <div className="bottom-bar">
      <div 
        className={`bottom-bar-item ${activeTab === 'home' ? 'active' : ''}`} 
        onClick={() => handleTabClick('home', '/dashboard')}
      >
        {activeTab === 'home' ? <HomeBlackIcon className="icon" /> : <HomeWhiteIcon className="icon" />}
        <span>Home</span>
      </div>
      <div 
        className={`bottom-bar-item ${activeTab === 'cart' ? 'active' : ''}`} 
        onClick={() => handleTabClick('cart', '/wallet')}
      >
        {activeTab === 'cart' ? <CartBlackIcon className="icon" /> : <CartWhiteIcon className="icon" />}
        <span>Cards</span>
      </div>
      <div 
        className={`bottom-bar-item ${activeTab === 'profile' ? 'active' : ''}`} 
        onClick={() => handleTabClick('profile', '/profile')}
      >
        {activeTab === 'profile' ? <ProfileBlackIcon className="icon" /> : <ProfileWhiteIcon className="icon" />}
        <span>Profile</span>
      </div>
    </div>
  );
}

export default BottomBar;
